/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import { graphql, useStaticQuery } from 'gatsby'
import React, { useState } from 'react'
import styled from 'styled-components'

import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import ParseContent from 'components/shared/ParseContent'

// Elements
import ImageBackground from 'components/elements/ImageBackground'

// Images
import Logo from 'img/logo-wit.svg'

const Team = ({ employeeIds }) => {
  const { 
    allWordpressWpTeam: team 
  } = useStaticQuery(graphql`
   {
      allWordpressWpTeam {
        edges {
          node {
            wordpress_id
            acf {
              teamlid {
                image {
                  localFile {
                    childImageSharp {
                      fluid(quality: 100, maxWidth: 300) {
                        ...GatsbyImageSharpFluid_withWebp
                      }
                    }
                  }
                }
                name
                department
              }
            }
          }
        }
      }
    }
  `)

  return (
    employeeIds.map((selectedId, index) => {

      const selected = team.edges.find(({ node }) => selectedId === node.wordpress_id)

      if(!selected) {
        return null;
      }
      
      return (
        <div key={index} className="col-12 col-md-4 col-lg-3 mt-5 d-flex">
          <Employee data={selected.node.acf.teamlid} />
        </div>  
      )
    })
  )
}

export default Team

const EmployeeBlock = styled.div`
  background-color: ${props => props.theme.color.contrast};
  border-radius: 25px;
  box-shadow: 0 0 15px rgba(0, 0, 0, .3);
`

const EmployeeDescription = styled(ParseContent)`
  color: ${props => props.theme.color.text.light};
  font-size: ${props => props.theme.font.size.m};

  & h1, & h2, & h3 {
    font-weight: ${props => props.theme.font.weight.s};

    & strong {
      font-weight: ${props => props.theme.font.weight.xl};
    }
  }

  & h2 {
    font-size: ${props => props.theme.font.size.l};
  }

  & p {
    text-align: left;
    line-height: 23px;
    
    & strong {
      font-weight: ${props => props.theme.font.weight['700']};
    }
  }
`

const EmployeeImage = styled(ImageBackground)`
  height: 250px;
  width: 200px;
  margin-top: -50px;
`

const AlterImg = styled.img`
  width: 200px;
  height: auto;

  @media (max-width: 991px){
    width: 150px;
  }
`

const Employee = ({ data }) => (
  <EmployeeBlock className="w-100">
    <>
      {data.image ? (
        <div className="d-flex align-items-start justify-content-end">
          <EmployeeImage src={data.image} style={{ backgroundSize: 'contain' }} />
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center">
          <div style={{ height: '200px' }} className="d-flex flex-column justify-content-center">
            <AlterImg src={Logo} />
          </div>
        </div>
      )}
      </>
    <div className="p-4">
      <EmployeeDescription content={data.name} />
    </div>
  </EmployeeBlock>
)
